import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "caret"]

  connect() {
    this.updateCaret()
  }

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    this.updateCaret()
  }

  show() {
    this.contentTarget.classList.remove("hidden")
    this.updateCaret()
  }

  hide() {
    this.contentTarget.classList.add("hidden")
    this.updateCaret()
  }

  updateCaret() {
    if (!this.hasCaretTarget) return

    if (this.contentTarget.classList.contains("hidden")) {
      this.caretTarget.textContent = "▶"
    } else {
      this.caretTarget.textContent = "▼"
    }
  }
}
